import loadable from "@loadable/component";

export const PhoneNumberPage = loadable(() => import("./PhoneNumberPage"), {
  resolveComponent: mod => mod.PhoneNumberPage,
});

export * from "./types";
